module.exports = __webpack_public_path__ + "Lato-Regular.ae05cb2ad509482faafc.woff2";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Regular.woff2
// module id = ../../../../../src/assets/fonts/Lato/Lato-Regular.woff2
// module chunks = styles